import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AdminLayout() {
    return (
        <Box sx={{ display: "flex", minHeight: "100vh" }}>

            {/* SIDEBAR */}
            <Sidebar />

            {/* CONTEÚDO PRINCIPAL */}
            <Box sx={{ flexGrow: 1, background: "#f5f6fa" }}>
                <Topbar />

                <Box sx={{ p: 3 }}>
                    <Outlet />
                </Box>
            </Box>

        </Box>
    );
}
